import PropTypes from 'prop-types'
import styled from 'styled-components'

import { CHART_SERIES_COLOR_MAP } from 'constants/colorMaps'
import DonutChart from 'components/Shared/charts/DonutChart'

import { useTranslation } from 'react-i18next'

const StyledWrapper = styled.div`
  display: flex;
  flex: initial;
  width: 188px;
  flex-direction: column;
  padding: 0;
  border-radius: 3px;
  background-color: #FFFFFF;
`

const ChartWrapper = styled.div`
  height: 160px;
  flex: 1;
`

const BondedUnbondedTicketsPieChart = ({ recentBondedTicketsCount, recentUnbondedTicketsCount }) => {
  const { t } = useTranslation()

  const data = [
    { name: t('dashboardPage.bonded'), color: CHART_SERIES_COLOR_MAP['bonded'], y: recentBondedTicketsCount },
    { name: t('dashboardPage.unbonded'), color: CHART_SERIES_COLOR_MAP['unbonded'], y: recentUnbondedTicketsCount },
  ]

  return (
    <StyledWrapper>
      <ChartWrapper>
        <DonutChart data={data} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

BondedUnbondedTicketsPieChart.propTypes = {
  recentBondedTicketsCount: PropTypes.number,
  recentUnbondedTicketsCount: PropTypes.number,
}

export default BondedUnbondedTicketsPieChart
